const siteRouters = [
  // 站点管理 - 其他
  {
    path: 'site',
    name: 'Site',
    redirect: '/manage/site/list',
    component: () => import(/* webpackChunkName: "SiteMain" */ '@/views/content'),
    meta: {
      sidebar: 1,
      authKey: ['auth_site'],
      title: 'com_sider_menu_site',
      disabled: false,
      icon: 'menu_site',
    },
    children: [
      // 站点管理 - 列表
      {
        path: 'list',
        name: 'SiteList',
        component: () => import(/* webpackChunkName: "SiteAdd" */ '@/views/site/list.vue'),
        meta: {
          sidebar: false,
          authKey: ['auth_site', 'auth_site_list'],
          title: 'com_sider_menu_site',
          disabled: false,
          breadcrumb: false,
          icon: 'site',
        },
      },

      // 添加新站点
      {
        path: 'add',
        name: 'SiteAdd',
        component: () => import(/* webpackChunkName: "SiteAdd" */ '@/views/site/update.vue'),
        meta: {
          sidebar: false,
          authKey: ['auth_site', 'auth_site_add'],
          title: 'com_sider_menu_site_add',
          disabled: false,
          icon: null,
          autoCollect: false,
        },
      },

      // 编辑站点
      {
        path: 'update/:id',
        name: 'SiteUpdate',
        component: () => import(/* webpackChunkName: "SiteAdd" */ '@/views/site/update.vue'),
        meta: {
          sidebar: false,
          authKey: ['auth_site', 'auth_site_edit'],
          title: 'com_sider_menu_site_edit',
          disabled: false,
          icon: null,
          autoCollect: false,
        },
      },

      // 详情
      {
        path: 'detail/:id',
        name: 'SiteDetail',
        component: () => import(/* webpackChunkName: "SiteDetail" */ '@/views/site/detail.vue'),
        meta: {
          sidebar: false,
          authKey: ['auth_site', 'auth_site_detail'],
          title: 'com_sider_menu_site_detail',
          disabled: false,
          icon: null,
          // 详情页不需要自动收集（但页面中有手动手集，因为涉及数据标题）
          autoCollect: false,
        },
      },
    ],
  },
];

export default siteRouters;
